import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { func_cookieSetting, isNumberValid, isNumberGreaterThanZero, isArrayNotEmpty, getStringUniqueId, getArrayLength, isNumber, reformatNumberDecimalPlaces } from "functions";

export function useRevenueColumns({ selectedMonth, isCompactView }) {

    function columns_outletRange() {
        let columnClassName = "column_outlet-range";

        return {
            Header: " ",
            sticky: "left",
            isRightColumnBorderVisible: true,
            isWidthResizingDisabled: true,
            columns: [
                {
                    headerCellClassName: columnClassName + " ",
                    Header: "Outlet",
                    id: "outletRange",
                    accessor: "OutletRange",
                    isRightColumnBorderVisible: true,
                    isWidthResizingDisabled: true,
                    bodyCellClassName: columnClassName + " ",
                    Cell: (props) => {
                        let rowIdx = props?.row?.index;

                        let totalRows = getArrayLength(props?.rows);

                        let display = "";
                        let isLastRow = (totalRows - 1 == rowIdx);
                        if (isLastRow) {
                            display = "Total";
                        }
                        else {
                            switch (rowIdx) {
                                case 0: display = "0 - 2 Outlets"; break;
                                case 1: display = "3 - 5 Outlets"; break;
                                case 2: display = "6 - 10 Outlets"; break;
                                case 3: display = "11 - 20 Outlets"; break;
                                case 4: display = "21 - 50 Outlets"; break;
                                case 5: display = "51 - 80 Outlets"; break;
                                case 6: display = "81 - 100 Outlets"; break;
                            }
                        }
            
                        return (
                            <div className={"noWrap-text-ellipsis " +
                                    (isLastRow? "font-weight-bold table_bordered-cell ":"")}
                            >
                                {display}
                            </div>
                        );
                    },
                    width: isCompactView? 80:150
                }
            ]
        }
    }

    function column_totalCharges(index) {
        let columnClassName = "column_total-charges";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Total Charges (RM)",
            id: "totalCharges" + index,
            accessor: "Total_Charges" + index,
            bodyCellClassName: columnClassName + " position-relative " + " justify-content-end",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";
                if (value_formatted != "-")
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
    
                let rowIdx = props?.row?.index;
                let totalRows = getArrayLength(props?.rows);
                let isLastRow = (totalRows - 1 == rowIdx);

                return (
                    <div className={"noWrap-text-ellipsis "  +
                            (isLastRow? "font-weight-bold table_bordered-cell ":"")}
                    >
                        {value_formatted}
                    </div>
                );
            },
            width: isCompactView? 80:160
        }
    }

    function column_totalOutlets(index) {
        let columnClassName = "column_total-outlets";

        return {
            headerCellClassName: columnClassName + " ",
            Header: () => (
                <div>
                    <div>Total Outlets</div>
                    <div className={"table_sub-info"}>[Chrg/Outlet(RM)]</div>
                </div>
            ),
            isHeaderMultipleLines: true,
            id: "totalOutlets" + index,
            accessor: "Total_Outlet" + index,
            bodyCellClassName: columnClassName + " position-relative ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";
    
                let rowIdx = props?.row?.index;
                let totalRows = getArrayLength(props?.rows);
                let isLastRow = (totalRows - 1 == rowIdx);

                let averageValue = props?.row?.original?.["Avg_By_Outlet" + index];

                return (
                    <div className={"d-flex align-items-center justify-content-end noWrap-text-ellipsis " +
                            (isLastRow? "font-weight-bold table_bordered-cell ":"")}
                    >
                        {value_formatted}

                        {/* Charge per Outlet */}
                        <div className={"table_sub-info pl-2"}>
                            ({isNumberValid(averageValue)? reformatNumberDecimalPlaces(averageValue):"-"})
                        </div>
                    </div>
                );
            },
            width: isCompactView? 55:150
        }
    }

    function column_totalClients(index) {
        let columnClassName = "column_total-clients";

        return {
            headerCellClassName: columnClassName + " ",
            Header: () => (
                <div>
                    <div>Total Clients</div>
                    <div className={"table_sub-info"}>[Chrg/Client(RM)]</div>
                </div>
            ),
            id: "totalClients" + index,
            accessor: "Total_Client" + index,
            isRightColumnBorderVisible: true,
            isWidthResizingDisabled: true,
            bodyCellClassName: columnClassName + " position-relative ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";
    
                let rowIdx = props?.row?.index;
                let totalRows = getArrayLength(props?.rows);
                let isLastRow = (totalRows - 1 == rowIdx);

                let averageValue = props?.row?.original?.["Avg_By_Client" + index];

                return (
                    <div className={"d-flex align-items-center justify-content-end noWrap-text-ellipsis " +
                            (isLastRow? "font-weight-bold table_bordered-cell ":"")}
                    >
                        {value_formatted}

                        {/* Charge per Client */}
                        <div className={"table_sub-info pl-2"}>
                            ({isNumberValid(averageValue)? reformatNumberDecimalPlaces(averageValue):"-"})
                        </div>
                    </div>
                );
            },
            width: isCompactView? 55:150
        }
    }

    function column_totalChargesPerOutlet(index) {
        let columnClassName = "column_total-charge-per-outlet";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Average Charge Per Outlet (RM)",
            id: "totalChargePerOutlet" + index,
            accessor: "Avg_By_Outlet" + index,
            bodyCellClassName: columnClassName + " position-relative " + " justify-content-end",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";
                if (value_formatted != "-")
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });

                let rowIdx = props?.row?.index;
                let totalRows = getArrayLength(props?.rows);
                let isLastRow = (totalRows - 1 == rowIdx);

                return (
                    <div className={"noWrap-text-ellipsis " +
                            (isLastRow? "font-weight-bold table_bordered-cell ":"")}
                    >
                        {value_formatted}
                    </div>
                );
            },
            width: isCompactView? 80:220
        }
    }

    

    function column_totalChargesPerClient(index) {
        let columnClassName = "column_total-charge-per-client";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Average Charge Per Client (RM)",
            id: "totalChargePerClient" + index,
            accessor: "Avg_By_Client" + index,
            bodyCellClassName: columnClassName + " position-relative " + " justify-content-end",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";
                if (value_formatted != "-")
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
    
                let rowIdx = props?.row?.index;
                let totalRows = getArrayLength(props?.rows);
                let isLastRow = (totalRows - 1 == rowIdx);

                return (
                    <div className={"noWrap-text-ellipsis " +
                            (isLastRow? "font-weight-bold table_bordered-cell ":"")}
                    >
                        {value_formatted}
                    </div>
                );
            },
            width: isCompactView? 80:220
        }
    }

    function column_monthlyData({ headerName, index }) {
        return {
            headerCellClassName: "d-flex justify-content-center",
            Header: headerName,
            isRightColumnBorderVisible: true,
            isWidthResizingDisabled: true,
            id: index + "",
            columns: [
                column_totalCharges(index),
                column_totalOutlets(index),
                column_totalClients(index),
                // column_totalChargesPerOutlet(index),
                // column_totalChargesPerClient(index)
            ]
        }
    }

    function column_averageCharges() {
        let columnClassName = "column_average-charges";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Average Charges (RM)",
            id: "averageCharges",
            accessor: "averageCharges",
            bodyCellClassName: columnClassName + " position-relative " + " justify-content-end",
            Cell: (props) => {
                let average = props?.cell?.value;
                average = isNumberValid(average)? func_cookieSetting.getFormattedPrice(average, { currencyDisabled: true }): "-";
    
                let rowIdx = props?.row?.index;
                let totalRows = getArrayLength(props?.rows);
                let isLastRow = (totalRows - 1 == rowIdx);

                return (
                    <div className={"noWrap-text-ellipsis " +
                        (isLastRow? "font-weight-bold table_bordered-cell ":"")}
                    >
                        {average}
                    </div>
                );
            },
            width: isCompactView? 80:160
        }
    }

    function column_averageOutlets() {
        let columnClassName = "column_average-outlets";

        return {
            headerCellClassName: columnClassName + " ",
            Header: () => (
                <div>
                    <div>Average Outlets</div>
                    <div className={"table_sub-info"}>[Chrg/Outlet(RM)]</div>
                </div>
            ),
            id: "averageOutlets",
            accessor: "averageOutlets",
            bodyCellClassName: columnClassName + " position-relative ",
            Cell: (props) => {
                let value = props?.cell?.value;
                value = isNumberValid(value)? value: "-";
    
                let rowIdx = props?.row?.index;
                let totalRows = getArrayLength(props?.rows);
                let isLastRow = (totalRows - 1 == rowIdx);

                let averageValue = props?.row?.original?.["averageChargePerOutlet"];

                return (
                    <div className={"d-flex align-items-center justify-content-end noWrap-text-ellipsis " +
                            (isLastRow? "font-weight-bold table_bordered-cell ":"")}
                    >
                        {value}

                        {/* Charge per Outlet */}
                        <div className={"table_sub-info pl-2"}>
                            ({isNumberValid(averageValue)? reformatNumberDecimalPlaces(averageValue):"-"})
                        </div>
                    </div>
                );
            },
            width: isCompactView? 55:150
        }
    }

    function column_averageClients() {
        let columnClassName = "column_average-clients";

        return {
            headerCellClassName: columnClassName + " ",
            Header: () => (
                <div>
                    <div>Average Clients</div>
                    <div className={"table_sub-info"}>[Chrg/Client(RM)]</div>
                </div>
            ),
            id: "averageClients",
            accessor: "averageClients",
            bodyCellClassName: columnClassName + " position-relative ",
            Cell: (props) => {
                let average = props?.cell?.value;
                average = isNumberValid(average)? average: "-";
    
                let rowIdx = props?.row?.index;
                let totalRows = getArrayLength(props?.rows);
                let isLastRow = (totalRows - 1 == rowIdx);

                let averageValue = props?.row?.original?.["averageChargePerClient"];

                return (
                    <div className={"d-flex align-items-center justify-content-end noWrap-text-ellipsis " +
                        (isLastRow? "font-weight-bold table_bordered-cell ":"")}
                    >
                        {average}

                        {/* Charge per Client */}
                        <div className={"table_sub-info pl-2"}>
                            ({isNumberValid(averageValue)? reformatNumberDecimalPlaces(averageValue):"-"})
                        </div>
                    </div>
                );
            },
            width: isCompactView? 55:150
        }
    }

    function column_averageChargesPerOutlet() {
        let columnClassName = "column_average-charge-per-outlet";

        return {
            headerCellClassName: columnClassName + " ",
            Header: "Average Charges Per Outlet (RM)",
            id: "averageChargePerOutlet",
            accessor: "averageChargePerOutlet",
            bodyCellClassName: columnClassName + " position-relative " + " justify-content-end",
            Cell: (props) => {
                let average = props?.cell?.value;
                average = isNumberValid(average)? func_cookieSetting.getFormattedPrice(average, { currencyDisabled: true }): "-";
    
                let rowIdx = props?.row?.index;
                let totalRows = getArrayLength(props?.rows);
                let isLastRow = (totalRows - 1 == rowIdx);

                return (
                    <div className={"noWrap-text-ellipsis " +
                        (isLastRow? "font-weight-bold table_bordered-cell ":"")}
                    >
                        {average}
                    </div>
                );
            },
            width: isCompactView? 80:230
        }
    }

    function column_averageChargesPerClient() {
        let columnClassName = "column_average-charge-per-client";

        return {
            headerCellClassName: columnClassName + " ",
            Header: isCompactView? "Avg. Ch./Cl.":"Average Charges Per Client (RM)",
            id: "averageChargePerClient",
            accessor: "averageChargePerClient",
            bodyCellClassName: columnClassName + " position-relative " + " justify-content-end",
            Cell: (props) => {
                let average = props?.cell?.value;
                average = isNumberValid(average)? func_cookieSetting.getFormattedPrice(average, { currencyDisabled: true }): "-";
    
                let rowIdx = props?.row?.index;
                let totalRows = getArrayLength(props?.rows);
                let isLastRow = (totalRows - 1 == rowIdx);
                
                return (
                    <div className={"noWrap-text-ellipsis " +
                            (isLastRow? "font-weight-bold table_bordered-cell ":"")}
                    >
                        {average}
                    </div>
                );
            },
            width: isCompactView? 80:230
        }
    }

    function column_averageAllMonths() {
        let selectedMonth_moment = moment(selectedMonth.current);
        let toDate = selectedMonth_moment.format("MMMM") + " (" + selectedMonth_moment.year() + ")";

        selectedMonth_moment.subtract(2, "months");
        let fromDate = selectedMonth_moment.format("MMMM") + " (" + selectedMonth_moment.year() + ")";

        return {
            headerCellClassName: "d-flex justify-content-center",
            Header: fromDate + " - " + toDate,
            id: "averageAllMonths",
            columns: [
                column_averageCharges(),
                column_averageOutlets(),
                column_averageClients(),
                // column_averageChargesPerOutlet(),
                // column_averageChargesPerClient(),
            ]
        }
    }

    let selectedMonth_moment = moment(selectedMonth.current);
    selectedMonth_moment.subtract(3, "months");
    let monthsColumns = [];
    for (let i = 2; i >= 0; i--) {
        selectedMonth_moment.add(1, "months");
        let column = column_monthlyData({
            headerName: selectedMonth_moment.format("MMMM") + " (" + selectedMonth_moment.year() + ")",
            index: i
        });
        monthsColumns.push(column);
    }



    return [
        columns_outletRange(),
        ...monthsColumns,
        column_averageAllMonths()
    ];
}